module.exports = __webpack_public_path__ + "img/52.93684286.jpg";